import type { ReactNode } from 'react';

export const symbol_person_heart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-220ZM228-360q67-30 128.5-45T480-420q7 0 13.5-.5T506-419q13 4 17.5 17t-.5 25q-5 12-17 15t-26 2q-57-5-111 9t-117 45q-14 7-23 21.5t-9 30.5v34h339q14 0 21.5 9.5T588-190q0 11-7 20.5t-22 9.5H220q-25 0-42.5-17.5T160-220v-34q0-38 19-65t49-41Zm144-163q-42-42-42-108t42-108q42-42 108-42t108 42q42 42 42 108t-42 108q-42 42-108 42t-108-42Zm172.5-43.5Q570-592 570-631t-25.5-64.5Q519-721 480-721t-64.5 25.5Q390-670 390-631t25.5 64.5Q441-541 480-541t64.5-25.5ZM480-631Zm236 239q20-20 36.5-34t45.5-14q37 0 59.5 25.5T880-357q0 15-6 30t-18 27L737-181q-9 9-21 9t-21-9L576-300q-13-13-18.5-28t-5.5-30q0-32 23-57t59-25q28 0 44 13t38 35Z"
		/>
	</svg>
);
